import React, {PureComponent} from 'react';
import {Card, CardBody, Col, Row, Input, Button} from "reactstrap";
import PropTypes from 'prop-types';
import api from 'api';
import CafeteryWrapInput from "../Question/answer-area/Components/cafeteryWrapInput";
import classnames from "classnames";
import {FormattedMessage} from "react-intl";

class ConfirmPasswordPage extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      password: '',
      errors: {},
      loading: false
    };

    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit() {
    this.setState({loading: true, errors: {}});

    api.survey.post.password(this.props.surveyId, {password: this.state.password})
      .then(_ => this.props.handleSuccess())
      .catch(e => {
        this.setState({
          loading: false,
          errors: {
            password: e.response.data.errors[0].m
          }
        })
      });
  }

  render() {
    const {errors, loading} = this.state;

    return (
      <Row className="justify-content-center password-container mt-5">
        <Col xs={12} lg={8} className={"question"}>
          <Card className={"card-body answer-area"}>
            <CardBody>
                <h1 className="w-100 mb-4">Wprowadź hasło do ankiety</h1>
                <CafeteryWrapInput
                    inputProps={{
                      type: "password"
                    }}
                    placeholder={"Wpisz hasło"}
                    error={!!errors.password}
                    value={this.state.password}
                    onChange={e => this.setState({password: e.target.value})}
                />
                {errors.password && <div className={"error"}>{errors.password}</div>}
                <button loading={loading} size="sm" className={classnames({
                  "w-100 text-left rounded-button mt-4 mb-3": true,
                  "disabled": loading
                })}
                    onClick={this.onSubmit} disabled={loading}>
                  <i className="fas fa-paper-plane text-white ml-3 mr-3"/> Potwierdź
                </button>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }
}

ConfirmPasswordPage.propTypes = {
  surveyId: PropTypes.number.isRequired,
  handleSuccess: PropTypes.func.isRequired
};

export default ConfirmPasswordPage;